import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { Link } from 'react-router-dom'; 
import InputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import TextEditor from "../../Components/Blogs/TextEditor";
import StlButton from "../../Components/StyledButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Typography from '@mui/material/Typography';

const StyledButton = styled(Button)(({ theme, variant }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  color: "rgba(0, 0, 0, 0.6)",
  fontSize: "16px",
  padding: "8px 12px",
  border: "1px solid rgba(0, 0, 0, 0.2)",
  width: "100%",
  "&:hover": {
    backgroundColor: "#fff",
    border: "1px solid rgba(0, 0, 0, 0.8)",
  },
  justifyContent: "start",
  textTransform: "none",
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: "2px solid red",
}));

const TextField = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    border: "1px solid",
    borderColor: "#E0E3E7",
    fontSize: 16,
    padding: "10px 12px",
  },
}));

const CreateBlog = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [slug, setSlug] = useState("");
  const [keywords, setKeywords] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");

  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const [showTitleError, setShowTitleError] = useState(false);
  const [showCatError, setShowCatError] = useState(false);
  const [showSlugError, setShowSlugError] = useState(false);
  const [showImageError, setShowImageError] = useState(false);
  const [showDescError, setShowDescError] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) navigate("/sign-in");

        const catResponse = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/v1/api/admin/get-all-category`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        // console.log("catResponse", catResponse);
        setCategoryList(
          catResponse?.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        );

        const subCatResponse = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/v1/api/admin/get-all-subcategory`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setSubCategoryList(
          subCatResponse?.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        );
      } catch (error) {
        if (error?.response?.data?.error === "failed to authenticate token")
          navigate("/sign-in");
      }
    };

    fetchData();
  }, [navigate]);

  const handleSubmit = async () => {
    const data = {
      title,
      category,
      subcategory,
      slug,
      keywords,
      metaTitle,
      metaDesc,
      image,
      description,
    };

    let formData = new FormData();
    for (const key in data) {
      if (data[key] !== "") formData.append(key, data[key]);
    }

    const authToken = localStorage.getItem("authToken");
    if (!authToken) navigate("/sign-in");

    if (title === "") {
      setShowTitleError(true);
    }
    if (category === "") {
      setShowCatError(true);
    }
    if (slug === "") {
      setShowSlugError(true);
    }
    if (image === "") {
      setShowImageError(true);
    }
    if (description === "") {
      setShowDescError(true);
    } else if (
      title !== "" ||
      category !== "" ||
      slug !== "" ||
      image !== "" ||
      description !== ""
    ) {
      // console.log("data", formData);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/api/admin/blogs`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      response.status === 200 && toast("Success! The blog has been created");
      navigate("/blogs");
    }
  };

  const handleDescriptionChange = (html) => {
    setDescription(html);
  };

  return (
    <div className="blog-container">
      <div className="blog-header">
      <p>
  <Link
    to="/dashboard"
    style={{
      textDecoration: 'none',
      color: '#454545',
      borderBottom: '1px solid transparent', // Initial border
      transition: 'border-bottom 0.3s ease', // Add smooth transition
    }}
    onMouseOver={(e) => (e.target.style.borderBottom = '1px solid #454545')} // Show underline on hover
    onMouseOut={(e) => (e.target.style.borderBottom = '1px solid transparent')} // Hide underline on mouseout
  >
    Home
  </Link>{" "}
  /{" "}
  <Link
    to="/blogs"
    style={{
      textDecoration: 'none',
      color: '#454545',
      borderBottom: '1px solid transparent', // Initial border
      transition: 'border-bottom 0.3s ease', // Add smooth transition
    }}
    onMouseOver={(e) => (e.target.style.borderBottom = '1px solid #454545')} // Show underline on hover
    onMouseOut={(e) => (e.target.style.borderBottom = '1px solid transparent')} // Hide underline on mouseout
  >
    Blogs
  </Link>{" "}
  / <strong>Create Blog</strong>
</p>
        <h4 style={{ fontSize: '1.5rem' }}>Create Blog</h4>
      </div>
      <Box sx={{ flexGrow: 1, marginTop: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Item>
              <FormControl variant="standard" fullWidth>
                <InputLabel
                  shrink
                  htmlFor="name"
                  sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
                >
                  Title
                </InputLabel>
                <TextField
                  autoFocus
                  value={title}
                  required
                  error={showTitleError ? true : false}
                  margin="dense"
                  id="name"
                  label="Title"
                  type="text"
                  fullWidth
                  size="small"
                  variant="outlined"
                  helperText={showTitleError && "Title is required"}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl
                fullWidth
                variant="standard"
                error={showCatError ? true : false}
              >
                <InputLabel
                  shrink
                  htmlFor="add-category"
                  sx={{
                    fontWeight: 700,
                    fontSize: "20px",
                    color: "#000",
                  }}
                >
                  Select Category
                </InputLabel>
                <Select
                  labelId="add-category"
                  id="add-category"
                  value={category}
                  // label="Category"
                  size="small"
                  onChange={(e) => setCategory(parseInt(e.target.value))}
                  input={<TextField />}
                >
                  {categoryList?.map((category, index) => (
                    <MenuItem key={index} value={category.id}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
                {showCatError && (
                  <FormHelperText>Category is required</FormHelperText>
                )}
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl fullWidth variant="standard">
                <InputLabel
                  shrink
                  htmlFor="add-sub-category"
                  sx={{
                    fontWeight: 700,
                    fontSize: "20px",
                    color: "#000",
                  }}
                >
                 Sub-Category
                </InputLabel>
                <Select
                  labelId="add-sub-category"
                  id="add-sub-category"
                  value={subcategory}
                  size="small"
                  onChange={(e) => setSubcategory(parseInt(e.target.value))}
                  input={<TextField />}
                >
                  {subCategoryList?.map(
                    (subCategory, index) =>
                      subCategory.categoryId === category && (
                        <MenuItem key={index} value={subCategory.id}>
                          {subCategory.name}
                        </MenuItem>
                      )
                  )}
                </Select>
                {/* {showCatError && (
                    <FormHelperText>Category is required</FormHelperText>
                  )} */}
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl variant="standard" fullWidth>
                <InputLabel
                  shrink
                  htmlFor="slug"
                  sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
                >
                  Slug
                </InputLabel>
                <TextField
                  autoFocus
                  value={slug}
                  required
                  error={showSlugError ? true : false}
                  margin="dense"
                  id="slug"
                  label="Slug"
                  type="text"
                  fullWidth
                  size="small"
                  variant="outlined"
                  helperText={showSlugError && "Category Name is required"}
                  onChange={(e) => setSlug(e.target.value)}
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl variant="standard" fullWidth>
                <InputLabel
                  shrink
                  htmlFor="keywords"
                  sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
                >
                  Keywords
                </InputLabel>
                <TextField
                  autoFocus
                  value={keywords}
                  required
                  margin="dense"
                  id="keywords"
                  label="Keywords"
                  type="text"
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => setKeywords(e.target.value)}
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl variant="standard" fullWidth>
                <InputLabel
                  shrink
                  htmlFor="meta-title"
                  sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
                >
                  Meta Title
                </InputLabel>
                <TextField
                  autoFocus
                  value={metaTitle}
                  required
                  margin="dense"
                  id="meta-title"
                  label="Meta Title"
                  type="text"
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => setMetaTitle(e.target.value)}
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl variant="standard" fullWidth>
                <InputLabel
                  shrink
                  htmlFor="meta-description"
                  sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
                >
                  Meta Description
                </InputLabel>
                <TextField
                  autoFocus
                  value={metaDesc}
                  required
                  margin="dense"
                  id="meta-description"
                  label="Meta Description"
                  type="text"
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => setMetaDesc(e.target.value)}
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Item>
              <FormControl variant="standard" fullWidth>
                <InputLabel
                  shrink
                  htmlFor="meta-description"
                  sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
                >
                  Featured Image
                </InputLabel>
                <StyledButton
                  variant="outlined"
                  component="label"
                  // style={showImageError && { border: "1px solid red" }}
                >
                  {image?.name || "No file chosen"}
                  <input
                    type="file"
                    hidden
                    onChange={(e) => setImage(e.target.files[0])}
                  />
                </StyledButton>
                <FormHelperText>Recommended image size 1920*300</FormHelperText>
                <div
                  style={{
                    color: "red",
                    textAlign: "left",
                    paddingLeft: "8px",
                  }}
                >
                  {showImageError && "Featured Image is required"}
                </div>
              </FormControl>
            </Item>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Item>
              <div>
              <Typography variant="subtitle1" color="textSecondary" style={{ textAlign: 'left', fontWeight: 700, fontSize: "15px", color: "#000"}}>
        Content 
      </Typography>
                <TextEditor
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </div>
              <div
                style={{
                  color: "red",
                  textAlign: "left",
                  paddingLeft: "8px",
                }}
              >
                {showDescError && "Content is required"}
              </div>
            </Item>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Item>
              <StlButton text={"submit"} onClick={handleSubmit} />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CreateBlog;
